module.exports = __webpack_public_path__ + "media/images/arrows/twisted/orange-right-321272f1e1dbcd477162c2dc4c18f71c.svg";